import React from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = ({ isOpen = false, onClose }) => {
  const handleLinkClick = () => {
    if (onClose && window.innerWidth < 992) {
      onClose();
    }
  };

  return (
    <div className={`app-sidebar py-3 d-flex flex-column ${isOpen ? 'show' : ''}`}>
      {/* Mobile-only Sidebar Header with Close Button */}
      <div className="d-flex d-lg-none justify-content-between align-items-center px-3 pb-2 mb-2 border-bottom border-secondary border-opacity-50">
        <div className="d-flex align-items-center gap-2">
          <i className="bi bi-water text-info fs-5"></i>
          <span className="fw-bold text-white small text-uppercase">Navigation Menu</span>
        </div>
        <button
          type="button"
          className="btn btn-sm btn-outline-light border-0 py-0 px-1"
          onClick={onClose}
          aria-label="Close menu"
        >
          <i className="bi bi-x-lg fs-5 text-secondary"></i>
        </button>
      </div>

      <div className="sidebar-heading">Main Menu</div>
      <NavLink to="/dashboard" onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-speedometer2"></i> Dashboard
      </NavLink>

      <div className="sidebar-heading">Master Management</div>
      <NavLink to="/products" onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-boxes"></i> Product Master
      </NavLink>
      <NavLink to="/accounts" onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-people"></i> Account Master
      </NavLink>

      <div className="sidebar-heading">Billing & Transactions</div>
      <NavLink to="/sales/new" onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-cart-plus"></i> Sale Entry (New)
      </NavLink>
      <NavLink to="/sales" end onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-receipt"></i> Sales History
      </NavLink>
      <NavLink to="/purchases/new" onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-bag-plus"></i> Purchase Entry (New)
      </NavLink>
      <NavLink to="/purchases" end onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-file-earmark-text"></i> Purchases History
      </NavLink>

      <div className="sidebar-heading">Payments & Expenses</div>
      <NavLink to="/payments/in" onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-arrow-down-left-circle-fill text-success"></i> Payment In (Receipt)
      </NavLink>
      <NavLink to="/payments/out" onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-arrow-up-right-circle-fill text-danger"></i> Payment Out (Payment)
      </NavLink>
      <NavLink to="/payments" end onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-cash-stack"></i> All Payments & Receipts
      </NavLink>
      <NavLink to="/box-tracking" onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-box-seam"></i> Box / Crate Tracking
      </NavLink>
      <NavLink to="/expenses" onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-wallet2"></i> Other Expenses
      </NavLink>

      <div className="sidebar-heading">Reports & Statements</div>
      <NavLink to="/reports/outstanding" onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-pie-chart-fill text-danger"></i> Outstanding Report
      </NavLink>
      <NavLink to="/reports/statement" onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-journal-text"></i> Unified Ledger Statement
      </NavLink>
      <NavLink to="/reports/sales" onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-graph-up-arrow"></i> Sales Report
      </NavLink>
      <NavLink to="/reports/purchases" onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-graph-down-arrow"></i> Purchase Report
      </NavLink>
      <NavLink to="/reports/stock" onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-boxes"></i> Stock Report
      </NavLink>

      <div className="sidebar-heading">Settings</div>
      <NavLink to="/settings/whatsapp" onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-whatsapp text-success"></i> WhatsApp Settings
      </NavLink>
      <NavLink to="/settings/firm" onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-building-gear"></i> Firm Details
      </NavLink>
      <NavLink to="/settings/password" onClick={handleLinkClick} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
        <i className="bi bi-shield-lock"></i> Change Password
      </NavLink>
    </div>
  );
};

export default Sidebar;
